// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Defines the default token refresh buffer duration.
 */
export var TokenRefreshBufferMs = 2 * 60 * 1000; // 2 Minutes

/**
 * Provides an {@link AccessTokenCache} implementation which clears
 * the cached {@link AccessToken}'s after the expiresOnTimestamp has
 * passed.
 */

var ExpiringAccessTokenCache =
/** @class */
function () {
  /**
   * Constructs an instance of {@link ExpiringAccessTokenCache} with
   * an optional expiration buffer time.
   */
  function ExpiringAccessTokenCache(tokenRefreshBufferMs) {
    if (tokenRefreshBufferMs === void 0) {
      tokenRefreshBufferMs = TokenRefreshBufferMs;
    }

    this.cachedToken = undefined;
    this.tokenRefreshBufferMs = tokenRefreshBufferMs;
  }

  ExpiringAccessTokenCache.prototype.setCachedToken = function (accessToken) {
    this.cachedToken = accessToken;
  };

  ExpiringAccessTokenCache.prototype.getCachedToken = function () {
    if (this.cachedToken && Date.now() + this.tokenRefreshBufferMs >= this.cachedToken.expiresOnTimestamp) {
      this.cachedToken = undefined;
    }

    return this.cachedToken;
  };

  return ExpiringAccessTokenCache;
}();

export { ExpiringAccessTokenCache };